/* Load */
    function load() {
        innerViewportHeight();
        innerViewportMargin();
    };
/* Load */
function copyMessage(text) {
    navigator.clipboard.writeText(text)
        .then(() => {
            UIkit.notification.closeAll();

            UIkit.notification({
                message: 'Скопировано в буфер обмена',
                status: 'success uk-notification-panel',
                pos: 'bottom-right',
                timeout: 2500,
            });
        })
        .catch((err) => {
            UIkit.notification.closeAll();

            UIkit.notification({
                message: 'Ошибка копирования: ' + err.message,
                status: 'danger uk-notification-panel',
                pos: 'bottom-right',
                timeout: 5000,
            });

            console.error(err);
        });
}
function copyMessageFromData(button) {
    // 1. Получаем строку из data-code — она содержит HTML-сущности
    let encodedCode = button.dataset.code;

    // 2. Декодируем HTML-сущности (например, &lt; → <, &gt; → >)
    const decoder = new DOMParser().parseFromString(encodedCode, 'text/html');
    let decodedCode = decoder.documentElement.textContent;

    // 3. Теперь декодированная строка — это JSON-строка с оригинальным кодом
    //    например: "\"<!DOCTYPE html>\\n<html lang=\\\"ru\\\">...\""
    try {
        const code = JSON.parse(decodedCode);

        // 4. Копируем в буфер обмена
        navigator.clipboard.writeText(code).then(() => {
            UIkit.notification.closeAll();
            UIkit.notification({
                message: 'Скопировано в буфер обмена',
                status: 'success uk-notification-panel',
                pos: 'bottom-right',
                timeout: 2500,
            });
        }).catch(err => {
            UIkit.notification.closeAll();
            UIkit.notification({
                message: 'Ошибка копирования: ' + err.message,
                status: 'danger uk-notification-panel',
                pos: 'bottom-right',
                timeout: 5000,
            });
        });
    } catch (e) {
        UIkit.notification.closeAll();
        UIkit.notification({
            message: 'Ошибка парсинга кода: ' + e.message,
            status: 'danger uk-notification-panel',
            pos: 'bottom-right',
            timeout: 5000,
        });
    }
}
/* Height */
    function innerViewportHeight() {
        var vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', vh + 'px');
    }
/* Height */
/* Left */
    function innerViewportMargin() {
        var left = window.innerWidth;
        if(left <= 1300) {
            var marginLeft = 15;
            if(left >= 640 && left <= 959) {
            var marginLeft = 30;
            }
            if (left >= 960) {
            var marginLeft = 40;
            }
        } else {
            var marginLeft = ((left - 1300) / 2) + 40;
        }
        document.documentElement.style.setProperty('--margin', marginLeft + 'px');
    }
/* Left */
/* Clean input text */
  function decodeEntities(encodedString) {
    encodedString = encodedString
          .replace(/\\"/g, '"') // Снимаем экранирование кавычек
          .replace(/\\'/g, '\'') // Снимаем экранирование апострофов
          .replace(/\\n/g, '\n') // Снимаем экранирование переводов строки
          .replace(/\\r/g, '\r') // Снимаем экранирование возвратов каретки
          .replace(/\\t/g, '\t') // Снимаем экранирование табуляции
          .replace(/\\:/g, ':') // Снимаем экранирование двоеточия (:)
          .replace(/\\\//g, '/') // Снимаем экранирование слэша (/)
          .replace(/\\u([0-9A-Fa-f]{4})/g, match => String.fromCharCode(parseInt(match.slice(2), 16))) // Декодируем экранированные юникод-символы
          .replace(/n(?![^\n]*)/g, '\n') // Преобразуем оставшийся одиночный "n" в символ перевода строки
          .replace(/<\/script>/g, '</script>') // Восстанавливаем </script>
          .replace(/<\/style>/g, '</style>')   // Восстанавливаем </style>
          .replace(/<script/g, '<script')       // Восстанавливаем <script
          .replace(/<style/g, '<style')         // Восстанавливаем <style
          .replace(/<\!--/g, '<!--')            // Восстанавливаем <!--
          .replace(/--\>/g, '-->')              // Восстанавливаем -->
          .replace(/]]\>/g, ']]>');             // Восстанавливаем ]]>
    return encodedString;
  }
/* Clean input text */
/* Clean and parse escaped JSON string */
function decodeEntitiesJson(encodedString) {
  if (typeof encodedString !== 'string') {
    return encodedString;
  }

  try {
    // Удаляем внешние кавычки, если строка заключена в них как JSON-строка
    let cleaned = encodedString.trim();
    if (cleaned.startsWith('"') && cleaned.endsWith('"')) {
      cleaned = cleaned.slice(1, -1);
    }

    // Декодируем стандартные escape-последовательности JSON
    cleaned = cleaned
      .replace(/\\n/g, '\n')
      .replace(/\\r/g, '\r')
      .replace(/\\t/g, '\t')
      .replace(/\\"/g, '"')
      .replace(/\\\\/g, '\\');

    // Парсим как JSON и сразу форматируем обратно с отступами
    const parsed = JSON.parse(cleaned);
    return JSON.stringify(parsed, null, 2);
  } catch (error) {
    // В случае ошибки возвращаем исходную строку (или можно вернуть null)
    return encodedString;
  }
}
/* Clean and parse escaped JSON string */
/* Speak Message */
  /*
  function speakMessage(text) {
    if ('speechSynthesis' in window) {
        const utterance = new SpeechSynthesisUtterance(text);
        speechSynthesis.speak(utterance);
    } else {
        alert('Ваш браузер не поддерживает синтез речи.');
    }
  }
  */
/* Speak Message */